'use client'

import { useTheme } from '@/components/Theme/ThemeProvider'
import { getThemeForAgent } from '@/lib/features/animatedBackground/agentThemes'
import { useCopilotContext } from '@/lib/features/copilotv2/CopilotContext'
import { useEffect } from 'react'

/**
 * AccentColorSync
 *
 * Bridges the copilot agent type to the theme with smooth transitions.
 */
export function AccentColorSync() {
  const { currentAgent } = useCopilotContext()
  const { setTheme } = useTheme()

  useEffect(() => {
    if (currentAgent) {
      const themeMode = getThemeForAgent(currentAgent)

      console.log('[AccentColorSync] Agent changed, updating theme:', {
        currentAgent,
        themeMode,
        timestamp: new Date().toISOString(),
      })

      setTheme(themeMode)
    }
  }, [currentAgent, setTheme])

  return null
}
